window.Theme = window.Theme || {};
Theme.Product = (() => {
  // let productSlider, productThumbSlider; // already declared globally in theme-scripts.liquid
  let currentVideo = null;
  const PDP_DEBUG = false;
  const PDP_MOBILE_BREAKPOINT = 992;

  function logPdpSlider(...args) {
    if (!PDP_DEBUG) return;
    console.log('[PDP Slider]', ...args);
  }

  const getMousePos = (e) => {
    var pos = e.currentTarget.getBoundingClientRect();
    return {
      x: e.clientX - pos.left,
      y: e.clientY - pos.top,
    };
  };

  function pauseMedia(container) {
    container.querySelectorAll('.yv-youtube-video').forEach(video =>
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    );
    container.querySelectorAll('.yv-vimeo-video').forEach(video =>
      video.contentWindow.postMessage('{"method":"pause"}', '*')
    );
    container.querySelectorAll('video').forEach(video => video.pause());
  }

  function enforceMobileSliderHeight(sliderMain) {
    if (!sliderMain || window.innerWidth >= PDP_MOBILE_BREAKPOINT) return;

    const currentHeight = sliderMain.getBoundingClientRect().height;
    if (currentHeight > 0) return;

    const sectionRoot = sliderMain.closest('[id^="shopify-section-"]');
    let cssVarHeight = sectionRoot ? window.getComputedStyle(sectionRoot).getPropertyValue('--productSliderHeight').trim() : '';
    if (!cssVarHeight || cssVarHeight === 'adapt') {
      cssVarHeight = '400px';
    }

    const wrappers = sliderMain.querySelectorAll('.yv-product-slider-item .image-wrapper, .yv-product-slider-item .product-single__media');
    wrappers.forEach((el) => {
      el.style.setProperty('height', cssVarHeight, 'important');
      el.style.setProperty('min-height', '280px', 'important');
      el.style.setProperty('padding-bottom', '0px', 'important');
    });

    sliderMain.style.setProperty('min-height', '280px');
    const viewport = sliderMain.querySelector('.flickity-viewport');
    const track = sliderMain.querySelector('.flickity-slider');
    if (viewport) viewport.style.setProperty('min-height', '280px');
    if (track) track.style.setProperty('min-height', '280px');

    if (window.productSlider && typeof window.productSlider.resize === 'function') {
      window.productSlider.resize();
    }

    logPdpSlider('mobile height fallback applied', {
      cssVarHeight,
      wrappers: wrappers.length
    });
  }

  function enforceMobileSliderCellWidth(sliderMain) {
    if (!sliderMain || window.innerWidth >= PDP_MOBILE_BREAKPOINT || !window.productSlider) return;

    const viewport = sliderMain.querySelector('.flickity-viewport');
    const containerWidth = (viewport && viewport.getBoundingClientRect().width) || sliderMain.getBoundingClientRect().width;
    if (!containerWidth || containerWidth < 10) return;

    const cells = sliderMain.querySelectorAll('.yv-product-slider-item');
    if (!cells.length) return;

    const firstCellWidth = cells[0].getBoundingClientRect().width;
    if (firstCellWidth > 10) return;

    cells.forEach((cell) => {
      cell.style.setProperty('width', `${containerWidth}px`, 'important');
      cell.style.setProperty('max-width', `${containerWidth}px`, 'important');
      cell.style.setProperty('min-width', `${containerWidth}px`, 'important');
    });

    try {
      window.productSlider.reloadCells();
      window.productSlider.resize();
      window.productSlider.select(window.productSlider.selectedIndex || 0, false, true);
    } catch (e) {
      logPdpSlider('cell width fallback error', e);
    }

    const lefts = Array.from(cells).map((cell) => cell.style.left || 'none');
    logPdpSlider('mobile cell width fallback applied', {
      containerWidth,
      firstCellWidthBefore: firstCellWidth,
      lefts
    });
  }

 function initProductSlider(section = document) {
    let sliderMain = section.querySelector('[data-flickity-product-slider]');
    if (!sliderMain) {
      logPdpSlider('initProductSlider: no slider found in section', section);
      return;
    }

    let optionContainer = sliderMain.getAttribute('data-flickity-product-slider');
    if (!optionContainer) {
      logPdpSlider('initProductSlider: missing data-flickity-product-slider options');
      return;
    }

    let options = JSON.parse(optionContainer);
    const isMobile = window.innerWidth < PDP_MOBILE_BREAKPOINT;
    const isMainProductSlider = sliderMain.hasAttribute('data-flickity-product-slider');

    // Mobile-safe options for PDP main slider:
    // - groupCells can collapse everything into one grouped slide on narrow/unstable layouts
    // - fade with grouped cells can lead to all cells appearing selected
    if (isMobile && isMainProductSlider) {
      options.groupCells = false;
      options.fade = false;
      options.draggable = true;
      options.cellAlign = 'center';
      options.contain = false;
      logPdpSlider('mobile options override', options);
    }
    logPdpSlider('initProductSlider:start', {
      width: window.innerWidth,
      hasDesktopOnly: sliderMain.hasAttribute('data-desktop-only'),
      hasMobileOnly: sliderMain.hasAttribute('data-mobile-only'),
      isEnabled: sliderMain.classList.contains('flickity-enabled'),
      itemCount: sliderMain.querySelectorAll('.yv-product-slider-item').length
    });

    function destroyIfEnabled() {
      if (sliderMain.classList.contains('flickity-enabled')) {
        logPdpSlider('destroyIfEnabled: destroying product slider');
        productSlider?.destroy();
      }
    }

    if (sliderMain.hasAttribute("data-mobile-only")) {
      if ($(window).width() < PDP_MOBILE_BREAKPOINT) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          setTimeout(() => productSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else if (sliderMain.hasAttribute("data-desktop-only")) {
      // Keep desktop-only behavior globally, but allow the main PDP slider to run on mobile
      // so mobile prev/next arrows can use Flickity.
      logPdpSlider('desktop-only branch', { isMainProductSlider, width: window.innerWidth });
      if ($(window).width() >= PDP_MOBILE_BREAKPOINT || isMainProductSlider) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          setTimeout(() => productSlider.resize(), 300);
          logPdpSlider('flickity init (desktop-only override)');
        }
      } else {
        destroyIfEnabled();
      }
    } else {
      if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          setTimeout(() => productSlider.resize(), 300);
          logPdpSlider('flickity init (default branch)');
        }
    }

    if (productSlider) {
      if (isMobile && isMainProductSlider) {
        productSlider.options.fade = false;
        sliderMain.classList.remove('is-fade');
        sliderMain.querySelectorAll('.yv-product-slider-item').forEach((cell) => {
          cell.style.opacity = '';
        });
      }

      enforceMobileSliderHeight(sliderMain);
      enforceMobileSliderCellWidth(sliderMain);
      setTimeout(() => {
        try {
          enforceMobileSliderCellWidth(sliderMain);
          productSlider.resize();
          productSlider.select(0, false, true);
          const cellWidths = (productSlider.cells || []).map((cell) => cell.size?.outerWidth || 0);
          logPdpSlider('post-resize cells', {
            selectedIndex: productSlider.selectedIndex,
            cells: cellWidths.length,
            cellWidths
          });
        } catch (e) {
          logPdpSlider('post-resize error', e);
        }
      }, 80);

      const prevBtn = sliderMain.querySelector('.flickity-prev-next-button.previous');
      const nextBtn = sliderMain.querySelector('.flickity-prev-next-button.next');
      const computed = window.getComputedStyle(sliderMain);
      const sliderRect = sliderMain.getBoundingClientRect();
      const firstItem = sliderMain.querySelector('.yv-product-slider-item');
      const firstItemRect = firstItem ? firstItem.getBoundingClientRect() : null;
      const firstWrapper = firstItem ? firstItem.querySelector('.image-wrapper, .product-single__media') : null;
      const firstWrapperStyle = firstWrapper ? window.getComputedStyle(firstWrapper) : null;
      logPdpSlider('post-init state', {
        isEnabled: sliderMain.classList.contains('flickity-enabled'),
        sliderDisplay: computed.display,
        sliderVisibility: computed.visibility,
        sliderOpacity: computed.opacity,
        sliderHeight: sliderRect.height,
        sliderWidth: sliderRect.width,
        firstItemHeight: firstItemRect ? firstItemRect.height : 'missing',
        firstWrapperHeight: firstWrapperStyle ? firstWrapperStyle.height : 'missing',
        firstWrapperPaddingBottom: firstWrapperStyle ? firstWrapperStyle.paddingBottom : 'missing',
        hiddenSlides: Array.from(sliderMain.querySelectorAll('.yv-product-slider-item')).filter(el => {
          const s = window.getComputedStyle(el);
          return s.display === 'none' || el.hidden;
        }).length,
        prevButton: prevBtn ? window.getComputedStyle(prevBtn).display : 'missing',
        nextButton: nextBtn ? window.getComputedStyle(nextBtn).display : 'missing'
      });

      if (prevBtn && !prevBtn.dataset.pdpLogBound) {
        prevBtn.dataset.pdpLogBound = 'true';
        prevBtn.addEventListener('click', () => {
          logPdpSlider('prev arrow click', { selectedIndex: productSlider.selectedIndex });
        });
      }
      if (nextBtn && !nextBtn.dataset.pdpLogBound) {
        nextBtn.dataset.pdpLogBound = 'true';
        nextBtn.addEventListener('click', () => {
          logPdpSlider('next arrow click', { selectedIndex: productSlider.selectedIndex });
        });
      }

      productSlider.on('change', function () {
        logPdpSlider('slide changed', { selectedIndex: productSlider.selectedIndex });
        pauseMedia(productSlider.element);
      });
    }
  }

  function initProductThumbSlider(section = document) {
    let sliderMain = section.querySelector('[data-flickity-product-thumb-slider]');
    if (!sliderMain) return;

    let optionContainer = sliderMain.getAttribute('data-flickity-product-thumb-slider');
    if (!optionContainer) return;

    let options = JSON.parse(optionContainer);

    function destroyIfEnabled() {
      if (sliderMain.classList.contains('flickity-enabled')) {
        productThumbSlider?.destroy();
      }
    }

    if (sliderMain.hasAttribute("data-mobile-only")) {
      if ($(window).width() < PDP_MOBILE_BREAKPOINT) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productThumbSlider = new Flickity(sliderMain, options);
          setTimeout(() => productThumbSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else if (sliderMain.hasAttribute("data-desktop-only")) {
      if ($(window).width() >= PDP_MOBILE_BREAKPOINT) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productThumbSlider = new Flickity(sliderMain, options);
          setTimeout(() => productThumbSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else {
      if (!sliderMain.classList.contains('flickity-enabled')) {
        productThumbSlider = new Flickity(sliderMain, options);
        setTimeout(() => productThumbSlider.resize(), 300);
      }
    }

    if (productThumbSlider) {
      productThumbSlider.on('change', function () {
        pauseMedia(productThumbSlider.element);
      });
    }
  }

  function findVisibleItems() {
    let mainSliderParent = document.getElementById('yv-product-gallery-slider');
    if (mainSliderParent) {
      let elements = mainSliderParent.getElementsByClassName('gallery-main-item');
      let thumbs = mainSliderParent.getElementsByClassName('gallery-thumbs-item');

      window.addEventListener('scroll', () => {
        Array.from(elements).forEach(item => {
          if (isOnScreen(item)) {
            let relatedThumb = mainSliderParent.querySelector('.gallery-thumbs-item[data-image="' + item.id + '"]');
            if (relatedThumb) {
              Array.from(thumbs).forEach(thumb => thumb.classList.remove('active'));
              relatedThumb.classList.add('active');
            }
          }
        });
      });
    }
    let mainTabsContent =  document.getElementById('yvProductFeatureListwrapper');
    if(mainTabsContent){
      let contentTabs = document.getElementsByClassName('yv-product-feature');	
      window.addEventListener('scroll', function(event){     
        Array.from(contentTabs).forEach(function(item) {
          if (isOnScreen(item)) {
            let headTabs = document.getElementsByClassName('feature-link');
            Array.from(headTabs).forEach(function(head) {
              head.parentNode.classList.remove('active');
            });
            var relatedHead = document.querySelector('.feature-link[href="#'+item.id+'"]');
            if(relatedHead){
              relatedHead.parentNode.classList.add('active');
            }
          }
        });
      });
    }
  }

  function sizeChart() {
    let sizeChartInit = document.querySelectorAll('.sizeChart-label');
    let sizeChartModel = document.getElementById('sizeChartModel');
    if (sizeChartInit && sizeChartModel) {
      let sizeChartClose = sizeChartModel.querySelector('#sizeChartClose');
      sizeChartInit.forEach(label => {
        label.addEventListener("click", e => {
          e.preventDefault();
          // $(sizeChartModel).fadeIn(100);
          document.body.classList.add('sizeChartOpen');
          sizeChartClose.focus();
        });
      });
      sizeChartClose.addEventListener("click", () => {
        document.body.classList.remove('sizeChartOpen');
        // $(sizeChartModel).fadeOut(100);
      });
    }
  }

  function initStickyAddToCart() {
    let mainProductForm = document.querySelector('.main-product-form');
    let stickyBar = document.getElementById('yvProductStickyBar');

    if (mainProductForm && stickyBar) {
      window.addEventListener('scroll', () => {
        if (isOnScreen(mainProductForm, true) || window.scrollY < mainProductForm.offsetTop) {
          stickyBar.classList.remove('show');
        } else {
          stickyBar.classList.add('show');
        }
      });
    }
  }

  function onReadyEvent() {
    setTimeout(function () {
      var thumbnails = document.querySelector('.yv-product-gallery-thumbs-container');
      var lastKnownY = window.scrollY;
      var currentTop = 0;
      if (thumbnails) {
        var initialTopOffset = parseInt(window.getComputedStyle(thumbnails).top);
        window.addEventListener('scroll', function (event) {
          var bounds = thumbnails.getBoundingClientRect(),
            maxTop = bounds.top + window.scrollY - thumbnails.offsetTop + initialTopOffset,
            minTop = thumbnails.clientHeight - window.innerHeight;
          if (window.scrollY < lastKnownY) {
            currentTop -= window.scrollY - lastKnownY;
          } else {
            currentTop += lastKnownY - window.scrollY;
          }
          currentTop = Math.min(Math.max(currentTop, -minTop), maxTop, initialTopOffset);
          lastKnownY = window.scrollY;
          thumbnails.style.top = "".concat(currentTop, "px");
        });
      }
    }, 1000);

    // jQuery('body').on('click', '.gallery-thumbs-item', function (e) {
    //   e.preventDefault();
    //   var destination = jQuery(this).attr('data-image');
    //   var top = jQuery('.shopify-section-main-header').height() + 10;
    //   if (jQuery('#' + destination + '.gallery-main-item').length > 0) {
    //     jQuery('html,body').animate({ scrollTop: (jQuery('#' + destination + '.gallery-main-item').offset().top) - top });
    //   }
    // });

    jQuery('body').on('click', '.pdp-view-close', function (e) {
      e.preventDefault();
      jQuery('#yvProductStickyBar').remove();
    });

    jQuery('body').on('click', '.feature-link', function (e) {
      e.preventDefault();
      let destination = jQuery(this).attr('href');
      let top = jQuery('.shopify-section-main-header').height() + 90;
      if (jQuery(destination).length > 0) {
        jQuery('html,body').animate({ scrollTop: (jQuery(destination).offset().top) - top });
      }
    });

    jQuery('body').on('change', '.sticky-bar-product-options', function () {
      let _section = jQuery(this).closest('.shopify-section');
      let option = jQuery(this).attr('data-name');
      let value = jQuery(this).val();
      let mainOption = _section.find('.productOption[name="' + option + '"]');
      if (mainOption.is(':radio')) {
        _section.find('.productOption[name="' + option + '"][value="' + CSS.escape(value) + '"]').attr('checked', true).trigger('click');
      } else {
        mainOption.val(value);
        let sectionId = document.querySelector('#' + _section.attr('id'));
        if (sectionId) {
          let optionSelector = document.querySelector('.productOption[name="' + option + '"]');
          if (optionSelector) {
            optionSelector.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });

    if (typeof fancySelector !== 'undefined') {
      Fancybox.bind(fancySelector, {
        touch: false,
        thumbs: {
          autoStart: true
        },
        on: {
          load: () => pauseMedia(document),
          done: () => pauseMedia(document)
        },
        Toolbar: {
          display: ["close"]
        }
      });
    }
  }

  function productZoomInit() {
    $('.yv-product-zoom').mouseenter(function (e) {
      $('.yv-product-zoom').removeClass('show');
      if ($(window).width() > 1021) {
        $(this).addClass('show');
      }
    });
    $('.yv-product-zoom').mousemove(function (e) {
      if ($(window).width() > 1021) {
        let t = getMousePos(e);
        this.querySelector('.gallery-cursor').style.translate = `${t.x}px ${t.y}px`;
      }
    });
    $('.yv-product-zoom').mouseleave(function (e) {
      $('.yv-product-zoom').removeClass('show');
    });
  }

  function load3DModel() {
    if (!window.Shopify) return;

    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: () => {
          if (!window.ShopifyXR || typeof window.ShopifyXR.addModels !== 'function') {
            document.addEventListener('shopify_xr_initialized', () => {
              load3DModel();
            });
            return;
          }

          document.querySelectorAll('[id^="product3DModel-"]').forEach((model) => {
            window.ShopifyXR.addModels(JSON.parse(model.textContent));
          });
          window.ShopifyXR.setupXRElements();
        }

      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: () => {
          document.querySelectorAll('.yv-product-model-item').forEach((model) => {
            let model3D = model.querySelector('model-viewer');
            model.modelViewerUI = new Shopify.ModelViewerUI(model3D);
            model3D.addEventListener('shopify_model_viewer_ui_toggle_play', () => {
              model.querySelectorAll('.close-product-model').forEach(el => el.classList.remove('hidden'));
              if (productSlider) {
                productSlider.options.draggable = false;
                productSlider.updateDraggable();
              }
            });
            model3D.addEventListener('shopify_model_viewer_ui_toggle_pause', () => {
              model.querySelectorAll('.close-product-model').forEach(el => el.classList.add('hidden'));
              if (productSlider) {
                productSlider.options.draggable = true;
                productSlider.updateDraggable();
              }
            });
            model.querySelectorAll('.close-product-model').forEach(el => {
              el.addEventListener('click', () => model.modelViewerUI.pause());
            });
          });
        }
      }
    ]);
  }

  function onLoad(section = document) {
    initProductSlider(section);
    initProductThumbSlider(section);
if (typeof findVisibleItems === 'function') {
  findVisibleItems();
}
    productZoomInit();
    sizeChart();
    initStickyAddToCart();
    load3DModel();
    onReadyEvent();
  }

  $(document).ready(function () {
    onLoad(document);
    onReadyEvent();

    function playVideo() {
      currentVideo = $('[data-reel-content] video')[0];
      if (currentVideo) {
        currentVideo.load();
        currentVideo.play();
      }
    }

    function pauseVideo() {
      if (currentVideo) {
        currentVideo.pause();
      }
    }
  });

  return {
    initProductSlider,
    initProductThumbSlider
  };
})();

if (document.querySelector('[data-flickity-product-slider]')) {
  window.addEventListener('resize', function(event) {
    Theme.Product.initProductSlider();
    Theme.Product.initProductThumbSlider();
    if (typeof findVisibleItems === 'function') {
      findVisibleItems();
    }
  });
}


